module.exports = __webpack_public_path__ + "static/environment-desktop.2f3d63b0.webp";